import { Injectable } from '@angular/core';
import {
  Action,
  AngularFirestore,
  AngularFirestoreCollection,
  DocumentChangeAction,
  DocumentReference,
  DocumentSnapshot,
} from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { Jugador } from '../models/jugador';

@Injectable({
  providedIn: 'root',
})
export class JugadorService {
  private jugadorCollection: AngularFirestoreCollection<Jugador>;

  constructor(private db: AngularFirestore) {
    this.jugadorCollection = this.db.collection<Jugador>('jugadores');
  }

  /**
   * GET ALL JUGADORESS
   */
  getAllJugador(): Observable<DocumentChangeAction<Jugador>[]> {
    return this.jugadorCollection.snapshotChanges();
  }

  /**
   * GET JUGADORES BY ID
   * @param jugadorId
   */
  getJugador(jugadorId: string): Observable<Action<DocumentSnapshot<Jugador>>> {
    return this.jugadorCollection.doc<Jugador>(jugadorId).snapshotChanges();
  }

  /**
   * CREATE NEW JUGADORES
   * @param newJugador
   */
  createJugador(newJugador: Jugador): Promise<DocumentReference> {
    return this.jugadorCollection.add(newJugador);
  }

  /**
   * UPDATE SELECTED JUGADORES
   * @param data
   * @param docId
   */
  updateJugador(data: Jugador, docId: string): Promise<void> {
    return this.jugadorCollection.doc<Jugador>(docId).update(data);
  }

  /**
   * DELETE JUGADORES
   * @param docId
   */
  deleteJugador(docId: string): Promise<void> {
    return this.jugadorCollection.doc<Jugador>(docId).delete();
  }

  /**
* GET ALL JUGADORES POR DE UNA ID DE QUINIELA
*/
  getAllJugadoresByIdQuiniela(idQuiniela: string): Observable<DocumentChangeAction<any>[]> {
    var query = this.db.collection('jugadores', (ref) =>
      ref.where('id_quiniela', '==', idQuiniela)
    );
    return query.snapshotChanges()
  }

  /**
* DELETE ALL JUGADORES DE UNA QUINIELA POR SU ID
*/
  deleteAllJugadoresByIdQuiniela(id_quiniela: any): void {
    let query = this.db.collection('jugadores', ref => ref.where('id_quiniela', '==', id_quiniela));
    query.get().toPromise().then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        doc.ref.delete();
      });
    });
  }

}
